import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ArcoVue from '@arco-design/web-vue';
import '@arco-design/web-vue/dist/arco.css';
import Vue3CountryIntl from 'vue3-country-intl';
import Vue3CountryFlag from 'vue3-country-intl/lib/vue3CountryFlag.esm.min.js';
let flagFilePath = require.context('vue3-country-intl/lib/country-flag-svgs', true, /\.svg$/)
// import css
import 'vue3-country-intl/lib/vue3-country-intl.css'
import 'vue3-country-intl/lib/vue3-country-flag.css'

const app = createApp(App)
app.component(Vue3CountryIntl.name, Vue3CountryIntl)

createApp(App).use(store).use(router).use(ArcoVue).use(Vue3CountryFlag, flagFilePath).mount('#app')
